__turbopack_context__.v({
  "block": "style-module-scss-module__yxMVFq__block",
  "container": "style-module-scss-module__yxMVFq__container",
  "icon": "style-module-scss-module__yxMVFq__icon",
  "wrapper": "style-module-scss-module__yxMVFq__wrapper",
});
